import { render, staticRenderFns } from "./PosAddPromotion.vue?vue&type=template&id=b2d65fb6&scoped=true&"
import script from "./PosAddPromotion.vue?vue&type=script&lang=js&"
export * from "./PosAddPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d65fb6",
  null
  
)

export default component.exports